import type { TFlag, TFlagConfig, TFlagEval, TFlagSnapshot } from "./types";

const FNV_PRIME = 16777619;
const FNV_OFFSET_BASIS = 2166136261;

export const hashToBucket = (input: string): number => {
  let hash = FNV_OFFSET_BASIS;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return (hash >>> 0) % 100;
};

const matchesOrg = (
  list: string[] | undefined,
  orgId: string,
  orgHash: string | null,
): boolean =>
  !!list &&
  (list.includes(orgId) || (orgHash !== null && list.includes(orgHash)));

export const evaluateFlag = (
  flag: TFlag,
  orgId: string,
  orgHash: string | null,
  planId: number | null,
): TFlagEval => {
  if (!flag.enabled) return { on: false };
  if (matchesOrg(flag.blocklistOrgIds, orgId, orgHash)) return { on: false };
  if (matchesOrg(flag.allowlistOrgIds, orgId, orgHash)) return { on: true };

  if (flag.audiences && flag.audiences.length > 0) {
    if (planId === null || !flag.audiences.includes(planId))
      return { on: false };
  }

  const bucket = hashToBucket(`${flag.name}:${orgId}`);
  return { on: bucket < (flag.rolloutPercentage ?? 0) };
};

export const evaluateAll = (
  config: TFlagConfig,
  orgId: string,
  orgHash: string | null,
  planId: number | null,
): TFlagSnapshot => {
  const snapshot: TFlagSnapshot = {};
  for (const key of Object.keys(config.flags)) {
    snapshot[key] = evaluateFlag(config.flags[key], orgId, orgHash, planId);
  }
  return snapshot;
};
